"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.MONTHS = exports.STRUCTURE_TARGET_TYPES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-float"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TargetShield = require("./TargetShield");

var _ergoStrings = require("../../Strings/ergoStrings");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _CordovaHelper = require("../../../../helpers/CordovaHelper");

var _DataStoreComponent2 = _interopRequireDefault(require("../../DataStoreComponent/DataStoreComponent2"));

var _DataStore = _interopRequireDefault(require("../../../../KESI2/Stores/DataStore2"));

var _data = require("./MockedData/data");

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var STRUCTURE_TARGET_TYPES = {
  OWN: 'own',
  OTHERS: 'others',
  BOTH: 'both'
};
exports.STRUCTURE_TARGET_TYPES = STRUCTURE_TARGET_TYPES;
var MONTHS = {
  0: 'Januar',
  1: 'Februar',
  2: 'März',
  3: 'April',
  4: 'Mai',
  5: 'Juni',
  6: 'Juli',
  7: 'August',
  8: 'September',
  9: 'Oktober',
  10: 'November',
  11: 'Dezember'
};
exports.MONTHS = MONTHS;

var ErgoTargetChooser = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(ErgoTargetChooser, _DataStoreComponent);

  var _super = _createSuper(ErgoTargetChooser);

  function ErgoTargetChooser(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ErgoTargetChooser);
    _this = _super.call(this, props, {
      dataStore: _DataStore["default"]
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleStructureAdd", function () {
      var ownMonthlyValueValid = true;
      var structureMonthlyValueValid = true;

      if (isNaN(_this.state.ownMonthlyValue) || _this.state.ownMonthlyValue <= 0) {
        ownMonthlyValueValid = false;
      }

      if (isNaN(_this.state.structureMonthlyValue) || _this.state.structureMonthlyValue <= 0) {
        structureMonthlyValueValid = false;
      }

      if (ownMonthlyValueValid && structureMonthlyValueValid) {
        var ownMonthlyValue = Math.round((0, _parseFloat2["default"])(_this.state.ownMonthlyValue) * 100) / 100;
        var structureMonthlyValue = Math.round((0, _parseFloat2["default"])(_this.state.structureMonthlyValue) * 100) / 100;
        var date = new Date();
        var time = new Date(date.getTime());
        time.setMonth(date.getMonth() + 1);
        time.setDate(0);
        var conditions = [{
          type: STRUCTURE_TARGET_TYPES.OWN,
          description: (0, _ergoStrings.getString)('OWN_UNITS'),
          value: ownMonthlyValue,
          time: time.getDate()
        }, {
          type: STRUCTURE_TARGET_TYPES.OTHERS,
          description: (0, _ergoStrings.getString)('STRUCTURE_UNITS'),
          value: structureMonthlyValue,
          time: time.getDate()
        }];
        var obj = {
          name: "".concat((0, _ergoStrings.getString)('STRUCTURE_TARGET'), " ").concat(MONTHS[date.getMonth()]),
          background: _data.MONTHLY_BACKGROUND,
          conditions: conditions,
          month: date.getMonth(),
          type: _TargetShield.TARGET_TYPES.OTHER
        };

        _this.props.onClose();

        _this.props.onChoose(obj);

        _this.setState(_this._getDefaultState());
      } else {
        _this.setState({
          ownMonthlyValueValid: ownMonthlyValueValid,
          structureMonthlyValueValid: structureMonthlyValueValid
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleAdd", function () {
      var targetValid = _this.state.name;
      var unitsValid = true;
      var timeValid = true;
      var obj;
      var nowDate = new Date();
      nowDate.setHours(0, 0, 0, 0);

      if (_this.state.predefinedTargetIndex) {
        var index = _this.state.predefinedTargetIndex - 1;
        obj = _objectSpread(_objectSpread({}, _data.mockedTargets[index]), {}, {
          startTime: nowDate.getTime(),
          type: _TargetShield.TARGET_TYPES.OTHER,
          contracts: []
        });

        _this.props.onClose();

        _this.props.onChoose(obj);

        _this.setState(_this._getDefaultState());
      } else {
        if (isNaN(_this.state.time) || _this.state.time <= 0) {
          timeValid = false;
        }

        if (isNaN(_this.state.value) || _this.state.units <= 0) {
          unitsValid = false;
        }

        if (targetValid && unitsValid && timeValid) {
          var value = Math.round((0, _parseFloat2["default"])(_this.state.value) * 100) / 100;
          var time = Math.round((0, _parseFloat2["default"])(_this.state.time) * 100) / 100;
          var conditions = [{
            description: _this.state.description,
            value: value,
            time: time,
            type: STRUCTURE_TARGET_TYPES.OWN
          }];
          obj = {
            name: _this.state.name,
            background: _this.state.background,
            conditions: conditions,
            startTime: nowDate.getTime(),
            type: _TargetShield.TARGET_TYPES.OTHER,
            contracts: []
          };

          _this.props.onClose();

          _this.props.onChoose(obj);

          _this.setState(_this._getDefaultState());
        } else {
          _this.setState({
            targetValid: targetValid,
            valueValid: unitsValid,
            timeValid: timeValid
          });
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "choosePictureFromGallery", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var picture, message, useButton, retakeButton, cancelButton;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _CordovaHelper.takePictureFromGallery)(250, 250, false);

            case 2:
              picture = _context.sent;
              message = /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  width: '100%',
                  height: '100%',
                  padding: '10px'
                }
              }, /*#__PURE__*/_react["default"].createElement("img", {
                src: 'data:image/jpeg;base64,' + picture
              }));
              useButton = {
                label: (0, _ergoStrings.getString)('USE_PICTURE'),
                callback: function callback() {
                  _this.setState({
                    background: 'data:image/jpeg;base64,' + picture
                  });
                }
              };
              retakeButton = {
                label: (0, _ergoStrings.getString)('RETAKE'),
                callback: function callback() {
                  _this.showBackgroundPicDialog();
                }
              };
              cancelButton = {
                label: (0, _ergoStrings.getString)('CANCEL')
              };
              (0, _MuiAlertHelper.showWideAlertReact)(message, null, (0, _ergoStrings.getString)('USE_PICTURE_TITLE'), true, [cancelButton, retakeButton, useButton], true);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "choosePictureFromCamera", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var picture, message, useButton, retakeButton, cancelButton;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _CordovaHelper.takePictureWithCamera)(250, 250, window.Camera.Direction.BACK, false);

            case 2:
              picture = _context2.sent;
              message = /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  width: '100%',
                  height: '100%',
                  padding: '10px'
                }
              }, /*#__PURE__*/_react["default"].createElement("img", {
                src: 'data:image/jpeg;base64,' + picture
              }));
              useButton = {
                label: (0, _ergoStrings.getString)('USE_PICTURE'),
                callback: function callback() {
                  _this.setState({
                    background: 'data:image/jpeg;base64,' + picture
                  });
                }
              };
              retakeButton = {
                label: (0, _ergoStrings.getString)('RETAKE'),
                callback: function callback() {
                  _this.showBackgroundPicDialog();
                }
              };
              cancelButton = {
                label: (0, _ergoStrings.getString)('CANCEL')
              };
              (0, _MuiAlertHelper.showWideAlertReact)(message, null, (0, _ergoStrings.getString)('USE_PICTURE_TITLE'), false, [cancelButton, retakeButton, useButton], true);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "showBackgroundPicDialog", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(error) {
        var chooseFromGalleryButton, chooseFromCameraButton, laterButton, errorMessage, htmlError;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  chooseFromGalleryButton = {
                    label: (0, _ergoStrings.getString)('CHOOSE_PICTURE_FROM_GALLERY'),
                    callback: function callback() {
                      setTimeout(function () {
                        _this.choosePictureFromGallery();
                      });
                    }
                  };
                  chooseFromCameraButton = {
                    label: (0, _ergoStrings.getString)('CHOOSE_PICTURE_FROM_CAMERA'),
                    callback: function callback() {
                      setTimeout(function () {
                        _this.choosePictureFromCamera();
                      });
                    }
                  };
                  laterButton = {
                    label: (0, _ergoStrings.getString)('MAYBE_LATER'),
                    callback: function callback() {
                      _this.dialogAlreadyShown = false;
                    }
                  };
                  errorMessage = _this.errorMessage || error;
                  htmlError = errorMessage ? "<div>".concat(errorMessage, "</div>") : null;
                  (0, _MuiAlertHelper.showWideAlertHtml)((0, _ergoStrings.getString)('CHOOSE_PICTURE'), (0, _ergoStrings.getString)('CHOOSE_PICTURE_TITLE'), true, [chooseFromGalleryButton, chooseFromCameraButton, laterButton], true, null);
                } catch (error) {
                  console.error('error getting policy number:', error);
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _this.state = _this._getDefaultState();
    return _this;
  }

  (0, _createClass2["default"])(ErgoTargetChooser, [{
    key: "_getDefaultState",
    value: function _getDefaultState() {
      return {
        name: '',
        value: '',
        time: '',
        description: '',
        background: '',
        targetValid: true,
        valueValid: true,
        timeValid: true,
        predefinedTargetIndex: 0,
        ownMonthlyValue: this.props.keyword === _TargetShield.TARGET_KEYWORDS.STRUCTURE ? this.props.currentUnits.own.toString() : '',
        structureMonthlyValue: this.props.keyword === _TargetShield.TARGET_KEYWORDS.STRUCTURE ? this.props.currentUnits.structure.toString() : '',
        ownMonthlyValueValid: true,
        structureMonthlyValueValid: true
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.keyword === _TargetShield.TARGET_KEYWORDS.STRUCTURE) {
        if (prevProps.currentUnits.own !== this.props.currentUnits.own) {
          this.setState({
            ownMonthlyValue: this.props.currentUnits.own.toString()
          });
        }

        if (prevProps.currentUnits.structure !== this.props.currentUnits.structure) {
          this.setState({
            structureMonthlyValue: this.props.currentUnits.structure.toString()
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isStructure = this.props.keyword === _TargetShield.TARGET_KEYWORDS.STRUCTURE;
      var date = new Date();
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        open: this.props.open,
        onClose: this.props.onClose
      }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, isStructure ? "Monatsziel f\xFCr ".concat(MONTHS[date.getMonth()], " festlegen") : 'Ihr neues persönliches Ziel'), isStructure ? /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        error: !this.state.ownMonthlyValueValid,
        label: 'Eigeneinheiten',
        type: 'text',
        value: this.state.ownMonthlyValue,
        onChange: function onChange(e) {
          return _this2.setState({
            ownMonthlyValue: e.target.value
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        error: !this.state.structureMonthlyValueValid,
        label: 'Fremdeinheiten',
        type: 'text',
        value: this.state.structureMonthlyValue,
        onChange: function onChange(e) {
          return _this2.setState({
            structureMonthlyValue: e.target.value
          });
        }
      })) : /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
        htmlFor: "predefinedTargets"
      }, "Kennzeichen der Erfolgreichen"), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        value: this.state.predefinedTargetIndex,
        onChange: function onChange(e) {
          _this2.setState({
            predefinedTargetIndex: e.target.value
          });
        },
        inputProps: {
          id: 'predefinedTargets'
        }
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        value: 0
      }), _data.mockedTargets.map(function (target, index) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: index,
          value: index + 1
        }, target.name);
      }))), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", null, "Oder Ziel selbst festlegen:"), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        fullWidth: true,
        disabled: this.state.predefinedTargetIndex > 0,
        error: !this.state.targetValid,
        label: 'Ziel',
        type: 'text',
        value: this.state.name,
        onChange: function onChange(e) {
          return _this2.setState({
            name: e.target.value
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        fullWidth: true,
        disabled: this.state.predefinedTargetIndex > 0,
        error: !this.state.valueValid,
        label: 'Einheiten',
        type: 'text',
        value: this.state.value,
        onChange: function onChange(e) {
          return _this2.setState({
            value: e.target.value
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        fullWidth: true,
        disabled: this.state.predefinedTargetIndex > 0,
        error: !this.state.timeValid,
        label: 'Zeit',
        type: 'text',
        value: this.state.time,
        onChange: function onChange(e) {
          return _this2.setState({
            time: e.target.value
          });
        },
        InputProps: {
          endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
            position: "end"
          }, "Tage")
        }
      }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        fullWidth: true,
        disabled: this.state.predefinedTargetIndex > 0,
        label: 'Beschreibung',
        type: 'text',
        value: this.state.description,
        onChange: function onChange(e) {
          return _this2.setState({
            description: e.target.value
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this.showBackgroundPicDialog
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: 'camera'
      }), " Hintergrundbild w\xE4hlen")), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this.props.onClose
      }, (0, _ergoStrings.getString)('CANCEL')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: isStructure ? this.handleStructureAdd : this.handleAdd
      }, (0, _ergoStrings.getString)('CONFIRM')))));
    }
  }]);
  return ErgoTargetChooser;
}(_DataStoreComponent2["default"]);

ErgoTargetChooser.propTypes = {
  keyword: _propTypes["default"].string,
  currentUnits: _propTypes["default"].object
};
var _default = ErgoTargetChooser;
exports["default"] = _default;